<template>
  <div ui-view style="padding: 0px 15px;">
    <div class="row" style="margin-bottom: 20px;">
      <div class="col-xs-12">
        <card
          :title="$t('Dashboard.CreateNewCase')"
        >
          <div class="row">
            <div class="col-md-4 col-xs-12">
              <div class="banner banner-Production" @click="onProductionClick()">
                <div class="plus-container">
                  <i class="fa fa-plus" style="font-size: 34px;"></i>
                </div>
                <div class="banner-content">
                  <h2 class="banner-title">{{ $t('Dashboard.NewProduction') }}</h2>
                  <p class="banner-copy">
                  {{ $t('Dashboard.ProductionDescription') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-xs-12">
              <div class="banner banner-DesignProduction" @click="onDesignProductionClick()">
                <div class="plus-container">
                  <i class="fa fa-plus" style="font-size: 34px;"></i>
                </div>
                <div class="banner-content">
                  <h2 class="banner-title">{{ $t('Dashboard.NewDesignProduction') }}</h2>
                  <p class="banner-copy">
                  {{ $t('Dashboard.DesignProductionDescription') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-xs-12">
              <div class="banner banner-design" @click="onDesignClick()">
                <div class="plus-container">
                  <i class="fa fa-plus" style="font-size: 34px;"></i>
                </div>
                <div class="banner-content">
                  <h2 class="banner-title">{{ $t('Dashboard.NewDesign') }}</h2>
                  <p class="banner-copy">
                    {{ $t('Dashboard.DesignDescription') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12 col-xs-12">
        <card
          :title="$t('Orders.currentOrders')"
          :refresh="loadOrders"
          :loader="orderLoader"
          :alert="orderAlert"
          :alert-text="orderAlertText"
          :alert-style="orderAlertStyle"
          :alert-icon="orderAlertIcon"
          alert-dismissable
          v-on:dismissalert="resetOrderAlerts"
          body-class="no-padding table-responsive"
        >
          <template v-if="hasOrders">
            <table class="datatable table table-striped primary dataTable no-footer">
              <thead>
                <tr>
                  <th>{{ $t('Orders.orderNum') }}</th>
                  <th>{{ $t('Common.date') }}</th>
                  <th>{{ $t('Common.status') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in orders">
                  <td>
                    <a v-on:click="openOrder(row.ID)">{{ row.transactionnum }}</a>
                  </td>
                  <td>{{ row.date | formatDate }}</td>
                  <td>
                    <order-status-badge :order="row"/>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="a-c pbottom-10">
              <button type="button" class="btn btn-info" v-on:click="showOrders"><i class="fa fa-inbox"></i> {{ $t('Orders.showAll') }}</button>
            </div>
          </template>
          <div class="empty-indicator" v-else>
            <i class="fa fa-inbox"></i> {{ $t('Orders.noOrders') }}
          </div>
        </card>
      </div>
      <div class="col-lg-6 col-md-12 col-xs-12">
        <card
          :title="$t('Projects.currentProjects')"
          :refresh="loadProjects"
          :loader="projectLoader"
          :alert="projectAlert"
          :alert-text="projectAlertText"
          :alert-style="projectAlertStyle"
          :alert-icon="projectAlertIcon"
          alert-dismissable
          v-on:dismissalert="resetProjectAlerts"
          body-class="no-padding table-responsive"
        >
          <template v-if="hasProjects">
            <table class="datatable table table-striped primary dataTable no-footer">
              <thead>
                <tr>
                  <th>{{ $t('Projects.projectName') }}</th>
                  <th>{{ $t('Common.lastmodified') }}</th>
                  <th>{{ $t('Common.status') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in projects">
                  <td>
                    <a v-on:click="openProject(row.ID)">{{ row.name }}</a>
                  </td>
                  <td>{{ row.lastmodified | formatDate }}</td>
                  <td>
                    <project-status-badge :status="row.status"/>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="a-c pbottom-10">
              <button type="button" class="btn btn-info" v-on:click="showProjects"><i class="fa fa-cog"></i> {{ $t('Projects.showAll') }}</button>
            </div>
          </template>
          <div class="empty-indicator" v-else>
            <i class="fa fa-cog"></i> {{ $t('Projects.noProjects') }}
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import ProjectStatusBadge from '../web-core/src/Elements/ProjectStatusBadge';
import OrderStatusBadge from '../web-core/src/Elements/OrderStatusBadge';
const view = require('../web-core/src/view.js'),
    viewData = {
      orderCount: 0,
      orders: [],
      orderLoader: '',
      orderAlert: '',
      orderAlertText: '',
      orderAlertStyle: '',
      orderAlertIcon: '',
      projectCount: 0,
      projects: [],
      projectLoader: '',
      projectAlert: '',
      projectAlertText: '',
      projectAlertStyle: '',
      projectAlertIcon: ''
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  components: {
    ProjectStatusBadge,
    OrderStatusBadge,
  },
  props: {

  },
  computed: {
    hasOrders() {
      return this.orders.length > 0;
    },
    hasProjects() {
      return this.projects.length > 0;
    }
  },
  mounted() {
    this.$parent.$parent.viewTitle = this.$t('Dashboard.title');
    this.reset();
  },
  methods: {
    onProductionClick() {
      this.$parent.$parent.$refs.newProject.openDialog('Production');
    },
    
    onDesignProductionClick() {
      this.$parent.$parent.$refs.newProject.openDialog('DesignProduction');
    },
    onDesignClick() {
      this.$parent.$parent.$refs.newProject.openDialog('Design');
    },
    reset() {
      for (var i in resetData) {
        if (resetData.hasOwnProperty(i)) {
          if (typeof resetData[i] != 'object') {
            viewData[i] = resetData[i];
          }
        }
      }

      this.loadOrders();
      this.loadProjects();
    },
    loadOrders() {
      viewData.orderLoader = this.$t('Orders.loading');
      this.$http.get(this.$root.url + 'order/', {params: {limit: 5}}).then(function(res) {
          viewData.orderLoader = '';
          viewData.orderCount = res.data.result.count;
          viewData.orders = res.data.result.data;
        }.bind(this),
        function(res) {
          viewData.orderLoader = '';
          viewData.orderAlertStyle = 'danger';
          viewData.orderAlert = this.$t('Orders.errorCouldNotLoad');
          if (typeof res.data.error != 'undefined') {
            viewData.orderAlertText = res.data.error;
          }
        }.bind(this));
    },
    openOrder(ID) {
      this.$parent.$parent.openView('OrderDetails', ID);
    },
    showOrders() {
      this.$parent.$parent.openView('Orders');
    },
    resetOrderAlerts() {
      this.orderAlert = '';
      this.orderAlertText = '';
      this.orderAlertStyle = '';
      this.orderAlertIcon = '';
    },
    loadProjects() {
      viewData.projectLoader = this.$t('Projects.loading');
      this.$http.get(this.$root.url + 'project/', {params: {limit: 5}}).then(function(res) {
          viewData.projectLoader = '';
          viewData.projectCount = res.data.result.count;
          viewData.projects = res.data.result.data;
        }.bind(this),
        function(res) {
          viewData.projectLoader = '';
          viewData.projectAlertStyle = 'danger';
          viewData.projectAlert = this.$t('Projects.errorCouldNotLoad');
          if (typeof res.data.error != 'undefined') {
            viewData.projectAlertText = res.data.error;
          }
        }.bind(this));
    },
    openProject(ID) {
      this.$parent.$parent.openView('ProjectDetails', ID);
    },
    showProjects() {
      this.$parent.$parent.openView('Projects');
    },
    resetProjectAlerts() {
      this.projectAlert = '';
      this.projectAlertText = '';
      this.projectAlertStyle = '';
      this.projectAlertIcon = '';
    },
  }
});
</script>




<style lang="scss" scoped>
.dashboard-cnt {
  display: flex;
  flex: 1;
  width: 100%;
  min-height: 70vh;
  flex-direction: column;
  justify-content: center;
  position: relative;
}

// .row {
//   display: flex;
//   flex: 1;
//   width: 100%;
//   justify-content: center;
//   position: relative;
// }

:root {
  --font-sans: 'Rubik', sans-serif;
  --font-serif: 'Cardo', serif;
}


.cell {
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: center;
  position: relative;
}

.cell img {
  max-width: 100%;
  object-fit: contain;
}

.plus-container {
  position: absolute;
  top: 0;
  right: 0;
  background: transparent;
  z-index: 10;
  margin: 5px;

  .plus-icon {
    position: relative;
    border: 1px dotted white;
    width: 3px;
    height: 3px;
    background-color: white;
    box-sizing: border-box;
    transform: scale(11);
    
    cursor: pointer;
  }
}


$bp-md: 600px;
$bp-lg: 800px;




.banner {
  --d: 700ms;
  --e: cubic-bezier(0.19, 1, 0.22, 1);

  position: relative;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  padding: 1rem;
  width: 100%;
  text-align: left;
  color: whitesmoke;
  background-color: whitesmoke;
  cursor: pointer;
  
  @media (min-width: $bp-md) {
    height: 150px;
  }
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 110%;
    background-size: cover;
    background-position: 0 0;
    transition: transform calc(var(--d) * 1.5) var(--e);
    pointer-events: none;
  }
  
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 200%;
    pointer-events: none;
    background-image: linear-gradient(
      to bottom,
      hsla(0, 0%, 0%, 0) 0%,
      hsla(0, 0%, 0%, 0.009) 11.7%,
      hsla(0, 0%, 0%, 0.034) 22.1%,
      hsla(0, 0%, 0%, 0.072) 31.2%,
      hsla(0, 0%, 0%, 0.123) 39.4%,
      hsla(0, 0%, 0%, 0.182) 46.6%,
      hsla(0, 0%, 0%, 0.249) 53.1%,
      hsla(0, 0%, 0%, 0.320) 58.9%,
      hsla(0, 0%, 0%, 0.394) 64.3%,
      hsla(0, 0%, 0%, 0.468) 69.3%,
      hsla(0, 0%, 0%, 0.540) 74.1%,
      hsla(0, 0%, 0%, 0.607) 78.8%,
      hsla(0, 0%, 0%, 0.668) 83.6%,
      hsla(0, 0%, 0%, 0.721) 88.7%,
      hsla(0, 0%, 0%, 0.762) 94.1%,
      hsla(0, 0%, 0%, 0.790) 100%
    );
    transform: translateY(-50%);
    transition: transform calc(var(--d) * 2) var(--e);
  }

  &.banner-Production {
    &:before {
      background-image: url('/img/workflows/Production.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    &:after {
      background-color: rgba(129,165,80,.5)
    }
  }
  &.banner-DesignProduction {
    &:before {
      background-image: url('/img/workflows/DesignProduction.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    &:after {
      background-color: rgba(129,165,80,.5)
    }
  }
  &.banner-design {
    &:before {
      background-image: url('/img/workflows/Design.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    &:after {
      background-color: rgba(129,165,80,.5)
    }
  }
}



.banner {
  .banner-content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 1rem;
    transition: transform var(--d) var(--e);
    z-index: 1;
    
    > * + * {
      margin-top: 1rem;
    }
  }

  .banner-title {
    font-size: 1.6rem;
    line-height: 1.2;
  }

  .banner-copy {
    font-family: var(--font-serif);
    font-size: 1.3rem;
    line-height: 1.35;
  }
}

@media (hover: hover) and (min-width: $bp-md) {
  .banner:after {
    transform: translateY(0);
  }
  
  .banner-content {
    transform: translateY(calc(100% - 4.5rem));
    
    > *:not(.banner-title) {
      opacity: 0;
      transform: translateY(1rem);
      transition:
        transform var(--d) var(--e),
        opacity var(--d) var(--e);
    }
  }
  
  .banner:hover,
  .banner:focus-within {
    align-items: flex-start;

    &:before { transform: translateY(-4%); }
    &:after { transform: translateY(-50%); }

    .banner-content {
      transform: translateY(0);

      > *:not(.banner-title) {
        opacity: 1;
        transform: translateY(0);
        transition-delay: calc(var(--d) / 8);
      }
    }
  }
  
  .banner:focus-within {
    &:before,
    &:after,
    .banner-content,
    .banner-content > *:not(.banner-title) {
      transition-duration: 0s;
    }
  }
}
</style>